module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "loginContainer"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tBygg din tavelvägg beta\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(" \n\t\tVälkommen till betaverisonen utav bygg din tavelvägg, var god skriv in ditt namn nedan. \n\t")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.setName
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.setName
    }
  }, [_vm._v(" SKICKA ")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "type": "submit"
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25fba49f!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/LoginTest.vue
// module id = 151
// module chunks = 0